import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { Box, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Typography } from '@mui/material';

interface SyncSectionProps {
  control: Control<any>;
}

export const SyncSection: React.FC<SyncSectionProps> = ({ control }) => {
  return (
    <Controller
      name="sync_on"
      control={control}
      render={({ field }) => (
        <FormControl component="fieldset">
          <FormLabel component="legend" sx={{ mb: 2, fontWeight: 600 }}>
            Select sync environment
          </FormLabel>
          <RadioGroup {...field} value={field.value || 'draft'}>
            <FormControlLabel
              value={SyncEnvironment.DRAFT}
              control={<Radio />}
              label={
                <Box>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    Draft
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Save in draft mode. No data will be sent to any system.
                  </Typography>
                </Box>
              }
            />
            <FormControlLabel
              value={SyncEnvironment.SANDBOX}
              control={<Radio />}
              label={
                <Box>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    Sandbox
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Save in sandbox mode. Data will be pushed to sandbox environment.
                  </Typography>
                </Box>
              }
              sx={{ mt: 1 }}
            />
            <FormControlLabel
              value={SyncEnvironment.PRODUCTION}
              control={<Radio />}
              label={
                <Box>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    Production
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Save in production mode. Data will be pushed to production environment.
                  </Typography>
                </Box>
              }
              sx={{ mt: 1 }}
            />
          </RadioGroup>
        </FormControl>
      )}
    />
  );
};

export default SyncSection;

export enum SyncEnvironment {
  DRAFT = 'draft',
  SANDBOX = 'sandbox',
  PRODUCTION = 'prod',
}
